import { useId } from 'react';
import { T, Var } from 'gt-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function TypedNameConfirmField({
  name,
  typed,
  onTypedChange,
}: {
  name: string;
  typed: string;
  onTypedChange: (value: string) => void;
}) {
  const id = useId();
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-sm font-normal">
        <T context="Confirmation prompt: the user must type this exact name before an overriding action unlocks">
          Type{' '}
          <span className="font-mono font-semibold">
            <Var>{name}</Var>
          </span>{' '}
          to confirm.
        </T>
      </Label>
      <Input
        id={id}
        value={typed}
        onChange={(event) => onTypedChange(event.target.value)}
        autoComplete="off"
        spellCheck={false}
        data-testid="typed-name-confirm"
      />
    </div>
  );
}
